"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CookieBanner = __importStar(require("../CookieBanner/CookieBanner"));
const react_ga_1 = __importDefault(require("react-ga"));
function gaEvent(action, category, cookieName) {
    const complianceCookie = CookieBanner.getComplianceCookie(cookieName);
    if (complianceCookie && complianceCookie.Analytics) {
        react_ga_1.default.event({ category: category, action: action });
    }
}
exports.gaEvent = gaEvent;
function GAnalytics(props) {
    let complianceCookie;
    const initializeGA = () => {
        if (complianceCookie && complianceCookie.Analytics) {
            console.log("analytics initialize");
            react_ga_1.default.initialize('UA-65129143-4', { debug: props.debug });
            react_ga_1.default.pageview(props.pagePath);
        }
    };
    react_1.useEffect(() => {
        complianceCookie = CookieBanner.getComplianceCookie(props.cookiename);
        initializeGA();
    }, []);
    return (react_1.default.createElement("div", null));
}
exports.default = GAnalytics;
//# sourceMappingURL=GAnalytics.js.map